// This file can be replaced during build by using the `fileReplacements` array.
// `npm run build -- --configuration=staff-nonprod` replaces `environment.ts`
// with `environment.staff.nonprod.ts`.
// To replace the files aws --profile {profile} s3 sync ./www s3://uoa-staff-prompts-spa-bucket-test --delete
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  wallboards: {
    student: {
      stats: {
        title: 'Student Contact Centre',
        baseUrl: 'https://3gyarsdo37.execute-api.ap-southeast-2.amazonaws.com/test/student-stats',
        mockData: null,
      },
      agents: {
        baseUrl: 'https://3gyarsdo37.execute-api.ap-southeast-2.amazonaws.com/test/student-agents',
        mockData: null,
      },
    },
    staff: {
      stats: {
        title: 'Staff Service Centre',
        baseUrl: 'https://3gyarsdo37.execute-api.ap-southeast-2.amazonaws.com/test/staff-stats',
        mockData: null,
      },
      agents: {
        baseUrl: 'https://3gyarsdo37.execute-api.ap-southeast-2.amazonaws.com/test/staff-agents',
        mockData: null,
      },
    },
    prompt: {
      useMockData: false,
      audit: {
        mockData: null,
        baseUrl: 'https://3gyarsdo37.execute-api.ap-southeast-2.amazonaws.com/test/audit',
      },
      prompts: {
        mockData: null,
        baseUrl: 'https://3gyarsdo37.execute-api.ap-southeast-2.amazonaws.com/test/prompts',
      },
      polly: {
        mockData: null,
        baseUrl: 'https://3gyarsdo37.execute-api.ap-southeast-2.amazonaws.com/test/polly',
      },
    },
  },
  auth: {
    cognitoAwsRegion: 'ap-southeast-2',
    cognitoUserPoolId: 'ap-southeast-2_gtuqqgIIq',
    cognitoDomain: 'https://uoapool-nonprod.auth.ap-southeast-2.amazoncognito.com',
    cognitoClientId: 'ghfo7f1in9fe8l066qc4hq3a6',
    redirectUri: 'https://amazon-connect-admin-staff.test.auckland.ac.nz',
    logoutUri: '',
    scopes: 'openid profile https://contact-centre-staff.auckland.ac.nz/wallboard-staff-spa',
    codeChallengeMethod: 'S256',
  },
  privateUrlKeyWords: {
    whoNeedBearerToken: [{ url: '3gyarsdo37.execute-api.ap-southeast-2.amazonaws.com', optional: true }],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
